"use strict";
var angular = require("angular");

var module = angular.module("accr.module", ["common.module"]);
require("./states.js").configure(module);


module.controller("viewAccrDialog.controller", require("./controllers/viewAccrDialog.controller"));
module.factory("accr.service", require("./services/accr.service"));